import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core'
import FormControl from '@material-ui/core/FormControl';
import { useQuery } from '@apollo/react-hooks'
import { examsPropertiesQueries } from '../../graphql/queries'
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import QuestionQuantitySlider from '../Content/QuestionsQuantitySlider';
import Switch from '@material-ui/core/Switch';
import SelectChipOption from '../SelectChipOption';
import CancelIcon from '@material-ui/icons/Cancel';
import CreateCustomExamButton from './CreateCustomExamButton';

const useStyles = makeStyles((theme) => ({
    controledField: {
        width: '100%',
        margin: 0
    },
    headerText: {
        marginBottom: 40
    },
    formControl: {
        marginBottom: 0
    },
    difficultyBox: {
        flexDirection: 'row',
        alignItems: 'center'
    }
})
)
const ContentBlock = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: flex-start
`

const FieldBox = styled.div`
    width: 100%;
    max-width: 46%;
    display: flex;
    flex-direction: column;
    align-self: flex-start;
    position: relative;
    border: 1px solid #f5f5f5;
    border-radius: 8px;
    margin-bottom: 32px;
    padding: 16px;
    @media(max-width: 1280px) {
        max-width: 45%
    }
    @media(max-width: 959px) {
        max-width: unset
    }
    & .boxLabel {
        position: absolute;
        top: -12px;
        padding: 0 8px;
        background-color: #FFF; 
    }
`

const SelectedItem = styled.div`
    font-size: 14px;
    padding: 5px 8px 5px 24px;
    color: #5C5C5C;
    background-color: #EFEFEF;
    margin: 4px;
    border-radius: 16px;
    position: relative;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 196px;
    .closeIcon {
        width: 18px;
        height: calc(100% - 16px);
        border-radius: 100%;
        padding: 0;
        position: absolute;
        top: 8px;
        left: 8px;
        outline: none;
        background-color: transparent;
        border: none;
        transition: 0.3s;
    }
    & svg {
        width: 16px;
        height: calc(100% - 16px);
        border-radius: 100%;
        padding: 0;
        position: absolute;
        top: 8px;
        left: 6px;
        outline: none;
        background-color: transparent;
        border: none;
        transition: 0.3s;
        color: #c5c5c5
    }
    & svg:hover {
        cursor: pointer;
        color: #5d5b5b
    }
`

const OptionsWrapper = styled.div`
    width: 100%;
    max-width: 100%;
    display: flex;
    flex-wrap: wrap;
    margin-top: 16px
`

const FiltrosPersonalizados = () => {
    const classes = useStyles();
    const [customInfo, setCustomInfo] = useState()
    const [institutions, setInstitutions] = useState([])
    const [yearOptions, setYearOptions] = useState([])
    const [examYear, setExamYear] = useState([])
    const [specialization, setSpecialization] = useState([])
    const [questionsQuantity, setQuestionsQuantity] = useState(10)
    const [difficulties, setDifficulties] = useState([])
    const [randomSwitch, setRandomSwitch] = useState({
        questions: false,
        answers: false,
    })

    const { data: dataYears } = useQuery(examsPropertiesQueries.GET_YEARS)
    const { data } = useQuery(examsPropertiesQueries.GET_INSTITUTIONS)
    const { data: dataDifficulties } = useQuery(examsPropertiesQueries.GET_DIFFICULTY)
    const { data: dataSpecialization } = useQuery(examsPropertiesQueries.GET_SPECIALIZATION)


    const handleDifficulty = (event) => {
        const current = difficulties.find((item) => item === event.target.value)
        if (!current) {
            setDifficulties([...difficulties, event.target.value])
        } else {
            setDifficulties([...difficulties].filter(id => (id !== event.target.value)))
        }
    };

    const handleSwitch = (event) => {
        setRandomSwitch({ ...randomSwitch, [event.target.name]: event.target.checked });
    };

    const handleInfo = () => {
        let customExam = {}
        customExam.instituicoes = institutions.map(item => item._id)
        customExam.anos = examYear
        customExam.especialidades = specialization.map(item => item._id)
        customExam.dificuldades = difficulties
        customExam.perguntasAleatorias = randomSwitch.questions
        customExam.respostasAleatorias = randomSwitch.answers
        customExam.quantidadeDePerguntas = questionsQuantity
        setCustomInfo({ ...customExam })
    }

    useEffect(() => {
        const anos = ((dataYears || []).anos || []).map(year => parseInt(year.ano))
        const anosFiltrados = []
        
        anos.forEach(ano => {
            const anoRepete = anosFiltrados.filter(year => year === ano) 
            if (anoRepete.length === 0) {
                anosFiltrados.push(ano)
            }
        })
        setYearOptions(anosFiltrados)
    }, [dataYears])

    useEffect(() => {
        handleInfo()
    }, [institutions, examYear, specialization, difficulties, randomSwitch, questionsQuantity]) //eslint-disable-line

    const handleClose = (element, exclude) => {
        let current
        if (element === 'instituicoes') {
            current = institutions.find((item) => item === exclude)
            !!current && setInstitutions([...institutions].filter(id => (id !== exclude)))
        }

        if (element === 'anos') {
            current = examYear.find((item) => item === exclude)
            !!current && setExamYear([...examYear].filter(id => (id !== exclude)))
        }

        if (element === 'especialidades') {
            current = specialization.find((item) => item === exclude)
            !!current && setSpecialization([...specialization].filter(id => (id !== exclude)))
        }
    }

    return (
        <>
            <Typography gutterBottom variant="body1" component="p" className={classes.headerText}>
                Procure provas ultilizando os filtros abaixo:
            </Typography>
            <ContentBlock>
                <FieldBox>
                    <SelectChipOption
                        fieldValue={institutions}
                        fieldOptions={((data || {}).instituicoes || []).map(item => ({
                            label: (item || {}).nome,
                            key: (item || {})
                        }))}
                        handleFieldValue={(e) => setInstitutions(e)}
                        label='Instituições'
                        fieldLabel='Instituição' />
                    {institutions.length ? <OptionsWrapper>
                        {institutions.map(option => (<SelectedItem>
                            <CancelIcon className="iconClose" onClick={() => handleClose('instituicoes', option)} />{(option || {}).nome}
                        </SelectedItem>))}
                    </OptionsWrapper> : ''}
                </FieldBox>
                <FieldBox>
                    <SelectChipOption
                        fieldValue={examYear}
                        fieldOptions={(yearOptions || []).map(year => ({
                            label: year,
                            key: year
                        }))}
                        handleFieldValue={(e) => setExamYear(e)}
                        label='Anos'
                        fieldLabel='Ano' />
                    {examYear.length ? <OptionsWrapper>
                        {examYear.map((option, key) => (<SelectedItem>
                            <CancelIcon className="iconClose" onClick={() => handleClose('anos', option)} />{option}
                        </SelectedItem>))}
                    </OptionsWrapper> : ''}
                </FieldBox>
                <FieldBox>
                    <SelectChipOption
                        fieldValue={specialization}
                        fieldOptions={((dataSpecialization || {}).especialidades || []).map(item => ({
                            label: (item || {}).nome,
                            key: (item || {})
                        }))}
                        handleFieldValue={(e) => setSpecialization(e)}
                        label='Especialidades'
                        fieldLabel='Especialidade' />
                    {specialization.length ? <OptionsWrapper>
                        {specialization.map(option => (<SelectedItem>
                            <CancelIcon className="iconClose" onClick={() => handleClose('especialidades', option)} />
                            {(option || {}).nome}
                        </SelectedItem>))}
                    </OptionsWrapper> : ''}
                </FieldBox>
                <FieldBox>
                    <Typography gutterBottom variant="body1" component="span" className="boxLabel">
                        Dificuldades:
                    </Typography>
                    <FormControl component="fieldset" className={classes.formControl}>
                        <FormGroup className={classes.difficultyBox}>
                            {((dataDifficulties || {}).dificuldades || []).map(item => (
                                <FormControlLabel
                                    control={<Checkbox checked={!!difficulties.find(id => id === item._id)}
                                        color="primary"
                                        onChange={handleDifficulty}
                                        value={item._id}
                                        name={(item || {}).nome} />}
                                    label={item.label} />))}
                        </FormGroup>
                    </FormControl>
                </FieldBox>
                <FieldBox>
                    <Typography gutterBottom variant="body1" component="span" className="boxLabel">
                        Quantidade máxima de perguntas:
                    </Typography>
                    <QuestionQuantitySlider questions={questionsQuantity} onChange={(t) => setQuestionsQuantity(t)} />
                </FieldBox>
                <FieldBox>
                    <Typography gutterBottom variant="body1" component="span" className="boxLabel">
                        Trazer aleatoriamente:
                    </Typography>
                    <FormGroup row>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={randomSwitch.questions}
                                    color="primary"
                                    onChange={handleSwitch}
                                    name="questions" />}
                            label="Perguntas" />
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={randomSwitch.answers}
                                    name="answers"
                                    onChange={handleSwitch}
                                    color="primary"
                                />}
                            label="Respostas" />
                    </FormGroup>
                </FieldBox>
            </ContentBlock>
            <CreateCustomExamButton params={customInfo} />
        </>
    )
}

export default FiltrosPersonalizados
